<template>
  <div class="wechat-tip-wrap">
    <div id="qr-code" class="wechat-code"></div>
    <div class="wechat-tip-text">很抱歉，请在微信中打开当前页面</div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "WeChat",
  props: {
    qrcodeUrl: String,
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      new QRCode("qr-code", {
        width: 100,
        height: 100,
        text: this.qrcodeUrl || "ewrewdsfsdfd",
        colorDark: "#000",
        colorLight: "#fff",
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wechat-code {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
